

















































import SeckillTimer from './seckill_timer.vue'
import { bookGoodsModelProvider } from '../model'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  {
    components: {
      SeckillTimer,
    },
  },
  () =>
    class {
      // 商品数据
      bookGoodsModel = bookGoodsModelProvider.inject()

      // 秒杀信息
      seckillInfo = computed(() => this.bookGoodsModel.value.seckillInfo)

      // 秒杀数据
      seckillData = computed(() => this.bookGoodsModel.value.seckillData)

      // 点击了解会员
      handleMemberClick = () => {
        dcb.navigateTo({
          url: 'dcb://MemberPage',
        })
      }
    },
)
